import React from 'react';
import { ActiveAdsContext } from './client/ActiveAdsContext.js';
import { BapAd, MetaData } from './client/Ad/adType.js';
import { DeviceTypeProvider, Device } from './client/Ad/useDeviceType.js';
import { UserIdProvider } from './client/Ad/useUserId.js';
import AktiveAnnonser from './client/AktiveAnnonser.js';

export interface IAppProps {
    loginId: string,
    userId: string,
    deviceType: Device,
    apis: {
        favorites: string;
        baseUrl?: string;
    },
    urls: {
        ad: string;
        imageCdn: string;
    }
    docs?: BapAd[]
    metaData?: MetaData,
    setMetaData: (metaData: MetaData) => void
}

const App: React.FunctionComponent<IAppProps> = (props) => {
    const [metaData, setMetaData] = React.useState(props.metaData);

    return <UserIdProvider initialValue={props.loginId}>
        <DeviceTypeProvider initialValue={props.deviceType}>
            <ActiveAdsContext.Provider value={{ ...props, metaData: metaData, setMetaData: setMetaData }}>
                <AktiveAnnonser></AktiveAnnonser>
            </ActiveAdsContext.Provider>
        </DeviceTypeProvider>
    </UserIdProvider>
};

export default App;

